import styled, { css } from 'styled-components';
import close from 'images/common-function/close2.svg';

export const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1;
  ${(props) =>
    !props.view &&
    css`
      visibility: hidden;
    `}
`;

export const Wrap = styled.div`
  box-sizing: border-box;
  height: 272px;
  position: absolute;
  bottom: -272px;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #fff;
  transition: transform 0.5s;
  transform: translateY(${(props) => (props.view ? `-272px` : `0`)});
  will-change: height;
`;

export const Header = styled.div`
  position: relative;
  padding: 20px 23px 25px;
  border-bottom: 1px solid #f5f5f5;
  > h2 {
    font-size: 12px;
    font-weight: bold;
    line-height: 11px;
    margin-bottom: 8px;
    font-family: Gulim, sans-serif;
  }
  > p {
    color: #999;
    font-size: 11px;
    line-height: 10px;
    font-family: '돋움', 'Dotum', sans-serif;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 4px;
  right: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  :before {
    content: '';
    display: block;
    width: 18px;
    height: 18px;
    background: url(${close}) no-repeat center center;
    background-size: 17px;
  }
`;

export const SubmitButton = styled.button`
  height: 41px;
  width: 100%;
  background-color: #ffca28;
  border-radius: 5px;
  margin-top: 10px;
  font-size: 12px;
  font-weight: bold;
  font-family: Gulim, sans-serif;
`;

export const Form = styled.form`
  padding: 20px 10px;
`;

export const InputWrap = styled.div`
  overflow: hidden;
  border-radius: 5px;
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  padding: 0 15px;
  height: 56px;
  background-color: #f5a0c1;
  > img {
    width: 26px;
    height: 26px;
    border-radius: 50%;
  }
  > div {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    span {
      font-size: 12px;
      line-height: 11px;
      font-weight: bold;
      font-family: Gulim, sans-serif;
    }
    p {
      font-size: 11px;
      line-height: 11px;
      font-family: '돋움', 'Dotum', sans-serif;
      margin-top: 6px;
    }
  }
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  background-color: #f26a94;
  color: #fff;
  padding: 0 15px;
  height: 50px;
  width: 100%;
  box-sizing: border-box;
  cursor: initial;
  > input {
    width: 100%;
    font-size: 12px;
    padding: 0 6px 7px;
    color: #fff;
    background-color: inherit;
    outline: none;
    border: none;
    border-bottom: 1px solid #fff;
    ::placeholder {
      color: rgba(255, 255, 255, 0.6);
    }
  }
`;
